//@ts-nocheck

/**
 * A comprehensive list of websites sorted from CMS.
 *
 * @type {readonly string[]}
 * @description Contains all Armani-related websites and brands
 * @example
 * // List includes various Armani brand websites
 * websites.includes('giorgio-armani'); // true
 */
export const websites = [
  'global',
  'giorgio-armani',
  'ga-poldo',
  'ga-neve',
  'thats-so-armani',
  'ginza-tower',
  'emporio-armani',
  'ea7',
  'armani-exchange',
  'armani-casa',
  'armani-fiori',
  'armani-dolci',
  'armani-beauty',
  'armani-restaurant',
  'armani-hotels-resorts',
  'armani-silos',
  'armani-clubs',
  'echi-dal-mondo',
] as const

/**
 * List of external Armani brand websites.
 *
 * @type {string[]}
 * @description Subset of websites considered external brands
 * @example
 * externalBrands.includes('armani-beauty'); // true
 */
export const externalBrands = [
  'ga-poldo',
  'ga-neve',
  'thats-so-armani',
  'ginza-tower',
  'armani-dolci',
  'armani-beauty',
  'armani-hotels-resorts',
  'armani-silos',
  'echi-dal-mondo',
]

/**
 * Filtered list of core Armani brands, excluding global and external brands.
 *
 * @type {string[]}
 * @description Core Armani brands derived from websites
 * @example
 * brands.includes('giorgio-armani'); // true
 * brands.includes('global'); // false
 */
export const brands = websites.filter(
  website => website !== 'global' && !externalBrands.includes(website)
)
